/**
 * `marked` configuration for legacy Markdown conversion (#248). Third-party
 * tokenizer API edge: `marked` signals "no match" with `undefined`, so this
 * file is exempt from the app-code Maybe rules (see eslint.config.js).
 */

import { Marked, type Token } from "marked";

export type HighlightToken = {
  type: "highlight";
  raw: string;
  text: string;
  tokens: Token[];
};

export const markdownLexer = new Marked({ gfm: true, breaks: false });
markdownLexer.use({
  tokenizer: {
    // Indented prose (tabs, 4+ spaces) is common in manuscripts; the editor
    // never treated it as a code block, so neither do we.
    code: () => undefined,
  },
  extensions: [
    {
      name: "highlight",
      level: "inline",
      start(src: string) {
        const index = src.indexOf("==");
        return index === -1 ? undefined : index;
      },
      tokenizer(src: string): HighlightToken | undefined {
        const match = /^==([^=\n]+)==/.exec(src);
        const inner = match?.[1];
        if (match === null || inner === undefined) return undefined;
        return {
          type: "highlight",
          raw: match[0],
          text: inner,
          tokens: this.lexer.inlineTokens(inner),
        };
      },
      renderer(token) {
        const tokens = (token as HighlightToken).tokens;
        return `<mark>${this.parser.parseInline(tokens)}</mark>`;
      },
    },
  ],
});
